<template>
  <div class="hotel-group-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('hotel_group.title') }}</h2>
      <router-link :to="{ name: 'AddHotelGroup' }" class="btn btn-primary">
        <b-icon icon="plus" class="icon-style"></b-icon>
        {{ $t('hotel_group.add') }}
      </router-link>
    </div>

    <CrudTable
      :columns="fields"
      :data-sources="hotelGroups"
      :loader="isLoading"
      list-url="public/hotel-groups"
      ref="action-table"
    >
      <template #cell(sr_no)="data">
        {{ (currentPage - 1) * perPage + data.index + 1 }}
      </template>

      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <router-link
            :to="{ name: 'EditHotelGroup', params: { id: data.item.id } }"
            class="btn btn-outline-primary btn-sm"
            title="Edit"
          >
            <i class="fas fa-edit"></i>
          </router-link>

          <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>

    <ConfirmDeleteModal
      v-if="selectedItem"
      :show.sync="showDeleteModal"
      :item-id="selectedItem.id"
      delete-url="/hotel-groups"
      :message="$t('hotel_group.confirm_delete_message', { name: selectedItem.name })"
      success-message="$t('hotel_group.deleted_successfully')"
      error-message="$t('common.something_went_wrong')"
      @deleted="handleItemDeleted"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/CrudTable.vue';
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue';

export default {
  name: 'HotelGroupList',
  components: {
    CrudTable,
    ConfirmDeleteModal,
  },
  data() {
    return {
      hotelGroups: [],
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      showDeleteModal: false,
      selectedItem: null,
      fields: [
        { key: 'sr_no', label: this.$t('common.sr_no'), sortable: false },
        { key: 'name', label: this.$t('hotel_group.name'), sortable: true },
        { key: 'description', label: this.$t('hotel_group.description'), sortable: false },
        { key: 'created_at', label: this.$t('hotel_group.created_at'), sortable: true },
        { key: 'actions', label: this.$t('hotel_group.actions'), sortable: false },
      ],
    };
  },
  methods: {
    confirmDelete(item) {
      this.selectedItem = item;
      this.showDeleteModal = true;
    },
    handleItemDeleted() {
      this.$refs['action-table'].refreshTableData();
      this.$bvToast.toast(this.$t('hotel_group.deleted_successfully'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
      this.showDeleteModal = false;
      this.selectedItem = null;
    },
  },
};
</script>